export default {
  letterSpacings: {
    default: 'normal',
    tracked: '0.04em'
  }
};
